/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'react',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit',
	'@ba/ba-ui-carbon',
	'../../../app/nls/StringResources'
], function(React, PropTypes, UI_CARBON_TOOLKIT, UI_CARBON, stringResources) {


	const { SVGIcon,
		SearchInput,
		Container,
		FlexLayout,
		FlexItem,
		Label,
		Multilinetruncatedtext } = UI_CARBON_TOOLKIT;

	const { ClickableTile } = UI_CARBON;

	class CustomWidgetGridView extends React.Component {
		constructor(props){
			super(props);
			this.state = {
				filteredWidgets: this.props.customWidgets
			};
		}

		_onSearchInputChange(searchText='') {
			let widgetsToSearch = this.props.customWidgets;
			if (searchText) {
				const isWidgetInList = (customWidget) => customWidget.title.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
				widgetsToSearch = this.props.customWidgets.filter(isWidgetInList);
			}
			this.setState({ filteredWidgets : widgetsToSearch });
		}

		_renderCustomWidgetTitle(title){
			return (
				<FlexItem>
					<Container className={'customWidgetTitleContainer'} width={74} height={32}>
						<Multilinetruncatedtext className={'customWidgetTitle'} numLines = {2} key={title} value={title} title={title} disableTooltip = {false} />
					</Container>
				</FlexItem>
			);
		}

		_renderCustomWidgetIcon(customWidget){
			if (customWidget.svgIcon) {
				return (
					<FlexItem>
						<SVGIcon
							iconId={customWidget.svgIcon}
							height={22}
							width={22}
							className='svgIcon'
						>
						</SVGIcon>
					</FlexItem>
				);
			} else if (customWidget.iconUrl) {
				return (
					<FlexItem>
						<img className="listitem-icon listitem-icon-detail"
							src={customWidget.iconUrl}
							width={22}
							height={22}
						/>
					</FlexItem>
				);
			}
		}

		_renderClickableTile(customWidget){
			return (
				<ClickableTile
					className="customWidgetTile"
					width={90}
					height={92}
					handleKeyDown={this.props.onKeyDown}
					handleClick={this.props.handleClick}
					data-id={customWidget.id}
				>
					<FlexLayout
						fullHeight
						direction="column"
						alignItems='center'
						justifyContent='center'
						tabIndex={0}
						className='customWidgetLayout'
						role={'button'}
						aria-label={customWidget.label}
						width={90}
						height={92}
					>
						{this._renderCustomWidgetIcon(customWidget)}
						{this._renderCustomWidgetTitle(customWidget.title)}
					</FlexLayout>
				</ClickableTile>
			);
		}

		_renderCustomWidgetItem(customWidget) {
			return (
				<FlexItem
					role={'group'} className='prop-item'
					data-name={customWidget.name}
					width={90}
					height={92}
					style={ { margin: '4px' } }
				>
					{this._renderClickableTile(customWidget)}
				</FlexItem>
			);
		}

		_renderCustomWidgets(){
			return(
				<FlexLayout
					fullHeight
					className='customWidgetsContainerLayout'
					direction="column"
					justifyContent='flex-start'
				>
					<FlexItem>
						<FlexLayout
							fullHeight
							direction="row"
							wrap='wrap'
						>
							{this.state.filteredWidgets.map( customWidget => this._renderCustomWidgetItem(customWidget))}
						</FlexLayout>
					</FlexItem>
				</FlexLayout>
			);
		}

		_renderSearchView(){
			return (
				<SearchInput
					className = {'customWidgetSearch'}
					value = {''}
					hideLeftIcon = {false}
					placeholder = {stringResources.get('searchPanel')}
					onChange = { userInput => this._onSearchInputChange(userInput) }
					size = 'sm'
				/>
			);
		}

		render(){
			return(
				<Container className={'customWidgetViewContainer'}>
					<Label className='customWidgetPanelHeader' label={stringResources.get('customWidgetsTitle')}/>
					<Container className={'customWidgetView'}>
						{this._renderSearchView()}
						{this._renderCustomWidgets()}
					</Container>
				</Container>
			);
		}
	}

	CustomWidgetGridView.propTypes = {
		customWidgets: PropTypes.array,
		onKeyDown: PropTypes.func,
		handleClick: PropTypes.func
	};

	return CustomWidgetGridView;
});
